import { useState } from "react"
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Alert from "../../../alert";
import { Alert as BootstrapAlert } from "reactstrap";
import bottyCustomizeIcon from '../../../../../../../../assets/images/ai-onboarding/botty-customize.svg'
import { 
    Button, 
    FormGroup,
    Label,
    Input,
    Spinner
} from "reactstrap";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import AIOnboardingService from "src/modules/3rd-party-management/apis/admin/AIOnboardingService";

const Confirmation = ({
    t,
    onNextButtonClicked,
    onBackButtonClicked
}) => {
    const [ confirmed, setConfirmed ] = useState(false)

    const {
        mutate: startProcessMutation,
        isLoading: startProcessIsLoading
    } = useMutation({
        mutationFn: async () => {
            const service = AIOnboardingService.getInstance();
            return await service.startProcess();
        },
        onError: () => {
            toast(t("An error occurred while starting process."), {
                type: "error"
            });
        },
        onSuccess: () => {
            onNextButtonClicked()
        }
    });

    return (
        <>
            <Alert 
                icon={bottyCustomizeIcon}
                title='Confirm to start'
                message=''
            />

            <div className="ai-onboarding-content-body">
                <div>
                    <BootstrapAlert
                        color="info"
                    >
                        <strong>{t('The uploaded file has been successfully received and is ready for processing.')}</strong><br />
                        {t('Please confirm to start the import.')} <em>{t('This action cannot be undone.')}</em>
                    </BootstrapAlert>
                    
                    <FormGroup check>
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={confirmed}
                                onChange={(e) => setConfirmed(e.target.checked)}
                            />
                            {t('I confirm that I want to start the import process.')}  
                        </Label>
                    </FormGroup>
                </div>
                <div className="ai-onboarding-tab-actions">
                    <Button 
                        disabled={!confirmed || startProcessIsLoading}
                        color="primary" 
                        onClick={startProcessMutation}
                    >
                        {startProcessIsLoading && (
                            <Spinner 
                                animation="border" 
                                variant="white" 
                                size="sm" 
                                className="me-1"
                            />
                        )}
                        {t('Next')}
                    </Button>
                    <Button 
                        outline
                        color="secondary" 
                        onClick={onBackButtonClicked}>
                        {t('Back')}
                    </Button>
                </div>
            </div>
        </>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user          :   state.Login.user,
        token         :   token
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(Confirmation))
)